exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tagline-hldr{position:relative;padding-top:6.5rem;padding-bottom:0}@media (min-width:48em){.tagline-hldr{padding-top:8.5rem;padding-bottom:0}}@media (min-width:76.8em){.tagline-hldr{padding-top:15rem;padding-bottom:0}}@media (min-width:99.2em){.tagline-hldr{padding-top:17.5rem;padding-bottom:0}}.tagline-hldr.no-top-padding{padding-top:0}.tagline-hldr .tagline{position:relative;background:#d94c02;text-align:center;padding:8rem 2rem}@media (min-width:76.8em){.tagline-hldr .tagline{padding:16rem 2rem}}@media (min-width:99.2em){.tagline-hldr .tagline{padding:21.5rem 2rem}}.tagline-hldr .tagline .title{font-size:3.2rem;line-height:4.8rem;font-weight:200;letter-spacing:.2rem;color:#fff}.tagline-hldr .tagline .title a{font-weight:200;opacity:.5}.tagline-hldr .tagline .title a:hover{opacity:1;text-decoration:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-Tagline/_index.scss
 ** module id = 201
 ** module chunks = 0
 **/